<div id="root">
  <router-outlet id="app-container"></router-outlet>
</div>
